<template>
	<div class="graph">
		<ScaleTabs
			v-bind:scale="scale"
			:scales="complianceScales"
			@change="setScale"></ScaleTabs>
		<DatePicker
			v-bind:date="date"
			v-bind:startDate="startDate"
			@previous="previous"
			@next="next"></DatePicker>
		<CountGraph1D
			v-bind:data="complianceData"
			v-bind:startDate="startDate"
			v-bind:date="date"
			v-bind:interval="interval"
			v-bind:binWidth="binWidth">
		</CountGraph1D>
	</div>
</template>

<script>
import Graph from './index'
import complianceScales from '../config/compliance-scales'

export default {
	name: 'medication-graph',
	extends: Graph,

	data() {
		return {
			scale: complianceScales[0],
			complianceScales
		}
	},

	computed: {
		/**
		 * @function 	complianceData
		 * @desc		Returns the compliance data with its time and count of medicines taken
		 */
		complianceData() {
			return this.data.map((compliance) => {
				let count = 0

				if (compliance.record) {
					Object.keys(compliance.record).forEach((timeOfDay) => {
						count += compliance.record[timeOfDay]
					})
				}

				return {
					time: parseInt(compliance.id),
					value: count
				}
			}).filter((compliance) => {
				return compliance.value != 0
			})
		}
	}
}
</script>
